import { DEFAULT_LAUNCH_LIST_QUERY, LIST_QUERY_KEYS, type LaunchListQuery } from "../models/launchList";

const isList = (key: keyof LaunchListQuery): key is (typeof LIST_QUERY_KEYS)[number] =>
    (LIST_QUERY_KEYS as readonly string[]).includes(key);

/*
    The list query lives in the URL so a filtered view is a shareable link. Only what differs
    from the default is written, so the plain route stays clean.
*/

export function queryFromSearch(params: URLSearchParams): LaunchListQuery {
    const query: LaunchListQuery = { ...DEFAULT_LAUNCH_LIST_QUERY };
    (Object.keys(query) as (keyof LaunchListQuery)[]).forEach((key) => {
        const value = params.get(key);
        if (value === null) return;
        if (isList(key)) query[key] = value.split(",").filter(Boolean);
        else if (key === "page" || key === "page_size") query[key] = Number(value) || query[key];
        else if (key === "attribute_match") query[key] = value === "all" ? "all" : "any";
        else query[key] = value;
    });
    return query;
}

export function searchFromQuery(query: LaunchListQuery): URLSearchParams {
    const params = new URLSearchParams();
    (Object.keys(query) as (keyof LaunchListQuery)[]).forEach((key) => {
        const value = isList(key) ? query[key].join(",") : String(query[key]);
        const initial = isList(key) ? "" : String(DEFAULT_LAUNCH_LIST_QUERY[key]);
        if (value !== initial) params.set(key, value);
    });
    return params;
}
